import { InstantSearch } from 'react-instantsearch';  
import InstantResults from '@klv/shared/search/instant-results';
import { generateClassName } from '@klv/shared/utils/functions';  
import SearchBox from '@klv/molecules/search-box';
import useIsHydrated from '@klv/hooks/useIsHydrated';
import { searchClient } from '@klv/utils/search-client';

import * as styles from './styles/searchHero.module.css';  

import type { ISearchHero } from './types';

const SearchHero = ({
  className = '',
  eyebrow,
  headline,
  subheadline,
  ...props
}: ISearchHero) => {

  const isHydrated = useIsHydrated();

  return (
    <div className={generateClassName([className, styles.searchHero])} {...props}>
      <div className={styles.searchHeroContent}>
        {eyebrow && (
          <div className={generateClassName(['eyebrow', styles.eyebrow])}>
            {eyebrow}
          </div>
        )}
        {headline && (
          <h1 className={generateClassName(['h1', styles.headline])}>
            {headline}
          </h1>
        )}
        {subheadline && (
          <h6
            className={generateClassName(['h6', styles.subheadline])}
            dangerouslySetInnerHTML={{ __html: subheadline }}
          />
        )}
        
        <div className={styles.searchBox}>
          {isHydrated && (
            <InstantSearch
              indexName='marketing_sites'
              searchClient={searchClient}
              insights
            >
              <SearchBox instantResults={<InstantResults/>}/>
            </InstantSearch>
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchHero;
